var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.gridConfiguration
        ? _c(_setup.Grid, {
            attrs: {
              gridConfiguration: _setup.gridConfiguration,
              itemData: _setup.bankdrafts,
              commandClick: _setup.onCommandClick,
              contextMenuItems: _setup.contextMenuItems,
            },
            on: {
              rowClick: _setup.onRowClick,
              contextMenuClicked: _setup.onContextMenuClicked,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }